class HttpService {
  defaultHeaders = {};

  setDefaultHeader(name, value) {
    this.defaultHeaders[name] = value;
  }

  removeDefaultHeader(name) {
    delete this.defaultHeaders[name];
  }

  getApiDomain(segments = []) {
    let domain = process.env.REACT_APP_API_ENDPOINT;
    if (domain.endsWith('/')) {
      domain = domain.substr(0, domain.length - 1);
    }

    return [domain, ...segments].join('/');
  }

  getApiEndpoint() {
    const domain = this.getApiDomain();

    // const lang = localStorage.getItem("i18nextLng");
    // return `${domain}/api/${lang}`;

    return `${domain}/api`;
  }

  get(url, /*data: any = {}, */ headers = {}) {
    return this.send({
      method: 'GET',
      url,
      headers,
      // body: JSON.stringify(data),
    });
  }

  post(url, data = {}, headers = {}) {
    return this.send({
      method: 'POST',
      url,
      headers,
      body: JSON.stringify(data),
    });
  }

  put(url, data = {}, headers = {}) {
    return this.send({
      method: 'PUT',
      url,
      headers,
      body: JSON.stringify(data),
    });
  }

  delete(url, data = {}, headers = {}) {
    return this.send({
      method: 'DELETE',
      url,
      headers,
      body: JSON.stringify(data),
    });
  }

  patch(url, data = {}, headers = {}) {
    return this.send({
      method: 'PATCH',
      url,
      headers,
      body: JSON.stringify(data),
    });
  }

  send(requestInfo) {
    return this.sendFetch(requestInfo, false, true);
  }

  async downloadFile(url, fallbackFilename = 'download') {
    const response = await this.get(url);
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.message || 'Download failed');
    }

    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    let filename = fallbackFilename;
    const match = disposition.match(/filename="?([^";]+)"?/i);
    if (match?.[1]) {
      filename = match[1];
    }

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }

  withFormData(method, url, data = null, headers = {}) {
    const options = {
      method,
      url,
      headers,
      body: data,
    };

    return this.sendFetch(options, true, true);
  }

  otherSite(url) {
    const options = {
      method: 'GET',
      url,
    };

    return this.sendFetch(options, true, false);
  }

  getApiAssets() {
    const domain = this.getApiDomain();
    console.log('domain--', domain);
    return `${domain}/assets`;
  }

  async createResourceFile(urlReq) {
    const segments = urlReq.split('/');
    let title = segments[segments.length - 1];
    if (title.includes('/') || title.includes('?') || !title.includes('.')) {
      if (this.isFacebookImage(urlReq)) {
        title = 'user-avatar-facebook.jpg';
      }
      if (this.isGoogleImage(urlReq)) {
        title = 'user-avatar-google.jpg';
      }
    }

    const response = await this.get(`/proxy/resource/${encodeURIComponent(urlReq)}`);
    const data = await response.blob();

    return new File([data], title, {
      type: response.headers.get('Content-Type') || undefined,
    });
  }

  getImageInServerOrBucket(filePath, folderName, serverFiles) {
    console.log('filePath-', filePath);
    console.log('folderName-', folderName);
    console.log('serverFiles-', serverFiles);

    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
      return filePath;
    }

    if (filePath.endsWith('/')) {
      filePath = filePath.substr(0, filePath.length - 1);
    }

    if (serverFiles.includes(filePath)) {
      return this.getImageInServer(`${folderName}/${filePath}`);
    }

    return this.getSpaceStoragePath(filePath);
  }

  async createResourceFileUserAvatar(filePath) {
    const url = this.getUserAvatarImage(filePath);
    return this.createResourceFile(url);
  }

  getImageInServer(filePath) {
    console.log('aaaaaaaaaaa');
    return `${this.getApiAssets()}/${filePath}`;
  }

  getUserAvatarImage(filePath) {
    return this.getImageInServerOrBucket(filePath || 'avatar.png', 'user-avatars', ['avatar.png']);
  }

  getSpaceStoragePath(filePath) {
    let domain = process.env.REACT_APP_DOMAIN || '';
    console.log('ppppp-', domain);
    console.log('jjjjj-', filePath);
    if (domain.endsWith('/')) {
      domain = domain.substr(0, domain.length - 1);
    }

    const storageFilePath = `${domain}/${filePath}`;

    return storageFilePath;
  }

  sendFetch(requestInfo, isFormData, isSame) {
    const { url } = requestInfo;
    delete requestInfo.url;

    requestInfo.headers = {
      // "Accept": "application/json",
      'X-Request-With': 'XMLHttpRequest',
      ...this.defaultHeaders,
      ...requestInfo.headers,
    };

    if (!isFormData) {
      requestInfo.headers['Content-Type'] = 'application/json';
    }

    requestInfo.redirect = 'follow';
    // console.log("requestInfo: ", requestInfo);

    const reqUrl = url[0] == '/' ? url.substr(1) : url;
    const apiDomain = isSame ? this.getApiEndpoint() : '';

    const handleError = (err) => {
      console.log(err);
      return Promise.reject(err);
    };

    try {
      const endpoint = !!apiDomain ? `${apiDomain}/${reqUrl}` : reqUrl;
      return fetch(endpoint, requestInfo)
        .then((response) => response)
        .catch(handleError);
    } catch (e) {
      return handleError(e);
    }
  }

  async createResourceFileImg(filePath) {
    const url = this.getImage(filePath);
    return this.createResourceFile(url);
  }

  getImage(filePath) {
    return this.getImageInServerOrBucket(filePath || 'noPhoto.png', 'files', ['noPhoto.png']);
  }
}

export default new HttpService();
